// @flow
/** @jsx jsx */

import * as React from 'react';
import { isNumber, isString } from 'lodash';

import { jsx } from '@emotion/core';

type Props = {
  children: React.Node,
  /** Show as display block? */
  isBlock?: boolean,
  /** HTML title text */
  title?: string,
  /** optional ID for the element */
  id?: string,
};

const truncatedTextCss = (isBlock: ?boolean) => ({
  display: isBlock ? 'block' : 'inline-block',
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

/**
 * Truncates text after 100% width an ellipsis
 */
const TruncatedText = ({ children, isBlock = false, title, id }: Props) => {
  const childrenArray = React.Children.toArray(children);
  const isEveryChildPrimitive = childrenArray.every(
    child => isString(child || '') || isNumber(child)
  );
  const joinedPrimitiveChildren = isEveryChildPrimitive
    ? childrenArray.join(' ')
    : undefined;

  const titleText = title ? title : joinedPrimitiveChildren;

  return (
    <span css={truncatedTextCss(isBlock)} id={id} title={titleText}>
      {children}
    </span>
  );
};

export default TruncatedText;
